/**
 * Extract a human-readable message from an axios-shaped error.
 *
 * Falls back through, in order:
 *   1. error.response.data.message   (nest exception filter default)
 *   2. error.response.data.error     (some legacy endpoints)
 *   3. error.message                 (network / JS error)
 *   4. the supplied fallback         (last resort — never empty)
 */
export function extractErrorMessage(err: unknown, fallback: string): string {
  if (!err) return fallback;
  if (typeof err === 'object') {
    const e = err as { response?: { data?: { message?: unknown; error?: unknown } }; message?: unknown };
    const dataMsg = e.response?.data?.message;
    if (typeof dataMsg === 'string' && dataMsg.length > 0) return dataMsg;
    const dataErr = e.response?.data?.error;
    if (typeof dataErr === 'string' && dataErr.length > 0) return dataErr;
    if (typeof e.message === 'string' && e.message.length > 0) return e.message;
  }
  return fallback;
}
